import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ArchiveReportDialogProps {
    open: boolean;
    onConfirm: () => void;
    onDecline: () => void;
    onClose: () => void;
    loading?: boolean;
}

export const ArchiveReportDialog = (props: ArchiveReportDialogProps) => {
    const { open, onConfirm, onDecline, onClose, loading } = props;
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('confirmationDialog.warning')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('statistics.archiveReportPrompt')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDecline} color="primary" disabled={loading}>
                    {t('statistics.archiveReportCancel')}
                </Button>
                <Button onClick={onConfirm} color="primary" autoFocus disabled={loading}>
                    {t('statistics.archiveReportConfirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
